export default __webpack_public_path__ + "static/media/2096.42b3fed9.png";